import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';

import styles from './loading-screen.module.css';

interface LoadingScreenSignature {
  Args: {
    isBeingRedirected?: boolean;
  };
}

const LoadingScreen = <template>
  <div class="flex flex-col items-center justify-center">
    <h1 class={{concat styles.feedback " " "mb-800"}}>
      {{if
        @isBeingRedirected
        (t "login.redirecting_message")
        (t "login.redirecting_back_message")
      }}<span>.</span><span>.</span><span>.</span>
    </h1>

    <svg class={{styles.spinner}} height="48" viewBox="0 0 50 50" width="48">
      <defs>
        <linearGradient
          id="loader__spinner-gradient"
          x1="0%"
          x2="100%"
          y1="0%"
          y2="0%"
        >
          <stop class={{styles.spinner-gradient-stop}} offset="0%"></stop>
          <stop class={{styles.spinner-gradient-stop}} offset="40%"></stop>
          <stop
            class={{styles.spinner-gradient-stop}}
            offset="60%"
            stop-opacity="0"
          ></stop>
        </linearGradient>
      </defs>
      <circle
        class={{styles.spinner-path}}
        cx="25"
        cy="25"
        fill="none"
        r="20"
        stroke-width="5"
      >
        <path d="M125,85 a60,60 0 1,0 -115,0"></path>
      </circle>
    </svg>
  </div>
</template> satisfies TOC<LoadingScreenSignature>;

export default LoadingScreen;
